'use strict';

/* global angular */

const ErrorPageController = require('./ErrorPageController');

angular
.module('dash.error', [])
.controller('ErrorPageController', ErrorPageController);



// WEBPACK FOOTER //
// ./src/app/dash/error/index.js